import type { VisVendorQueryRecord } from '@lib/kysely/visual/queries';
import { z, type ZodType } from 'zod/v4';

export const configuratorVendorSchema = z.object({
  id: z.string().transform((s) => s.toUpperCase()),
  name: z.string().nullable(),
}) satisfies ZodType<VisVendorQueryRecord>;
